import { render, staticRenderFns } from "./IklanBanner.vue?vue&type=template&id=59d03858"
import script from "./IklanBanner.vue?vue&type=script&lang=js"
export * from "./IklanBanner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports